
<div class="chat-container" [ngClass]="isPdfChat ? 'chat-pdf-container':''" *ngIf="isChatScreenOpen">
    <div class="chat-title">Questions about your data? Ask below... <span class="close-button" (click)="closeChatScreen()">&times;</span>
    </div>
    <div class="chat-message-list" #chatContainer>
      <ng-container>
        <div class="chat-message" [ngClass]="{'custom-position':msg.user.name !=='Ignatius','custom-width':msg.user.name ==='Ignatius'}" *ngFor="let msg of messages">
          <div class="message-avatar" *ngIf="msg.user.avatar">
            <img [src]="msg.user.avatar" alt="Avatar">
          </div>
          <div class="message-info">
            <div class="user-info">
              <div class="sender">{{ msg.user.name }} </div>
              <div class="date">{{ msg.date | date: 'shortTime' }}</div>
            </div>
            <div class="message" [ngClass]="{'custom-color':msg.user.name ==='Ignatius','custom-text':isPdfChat}" [innerHTML]="msg.text"></div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="chat-form" [ngClass]="isLoading ? 'align-items-center':''">
      <ng-container *ngIf="isLoading">
        <div class="preloader" *ngIf="!isOpenGovTheme">
          <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
          </div>
        </div>
        <div class="overlay" *ngIf="isOpenGovTheme">
          <div class="custom-spinner"></div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isLoading">
        <input type="text" value="{{ newMessage }}" (keyup)="setInputValue($event)" (keyup.enter)="sendMessage()" placeholder="Type a message..." #input>
        <button type="button" (click)="sendMessage()"><i class="icon-send"></i></button>
      </ng-container>
    </div>
  </div>
<button type="button" class="btn btn-primary border rounded-pill custom-button" *ngIf="!isPdfChat" (click)="supportClicked()">Support</button>